import { Modal, useSession } from '@cfs-fixings/shared'
import { ProjectResource, useGetAuthSessionQuery } from '@/api/serverApi'
import DuplicateProjectForm from '@/components/forms/projects/DuplicateProjectForm'

const textSpec = {
  title: 'Duplicate Project',
}

type PropTypes = {
  project: ProjectResource
  isOpen: boolean
  onSuccess?: () => void
  onClose: () => void
}

const DuplicateProjectModal = ({ project, isOpen, onSuccess, onClose }: PropTypes) => {
  const { user } = useSession({ getData: useGetAuthSessionQuery })

  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      title={textSpec.title}
      content={
        user
          ? (
            <DuplicateProjectForm
              project={project}
              onClose={onClose}
              onCompleted={() => onSuccess?.()}
            />
          )
          : <></>
      }
    />
  )
}

export default DuplicateProjectModal
